





































































import { defineComponent, reactive, ref, computed } from "@vue/composition-api";
import { ValidationObserver } from "vee-validate";
import LoadingButton from "@/shared/components/LoadingButton";
import { RasmusChangePasswordApiData } from ".";
import { RasmusUserPassword } from "@/features/rasmus-kids-club/shared";

import { ApiErrorType } from "@/features/rasmus-kids-club/shared";

import {
  rasmusRequest,
  getTranslatedErrorForMessage,
} from "@/features/rasmus-kids-club/shared/helpers";

export default defineComponent({
  name: "RasmusChangePasswordForm",
  components: {
    LoadingButton,
    ValidationObserver,
    RasmusUserPassword,
  },
  props: {
    uid: {
      type: Number,
      default: undefined,
    },
  },
  setup(props) {
    let formData = reactive({
      password: "",
      passwordConfirm: "",
      oldPassword: "",
    });

    let errors: ApiErrorType = reactive({
      messages: undefined,
    });

    let successMessage: { messages: undefined | string } = reactive({
      messages: undefined,
    });

    let isSubmitting = ref(false);
    const passwordComplexityTooLow = ref(false);

    const setPasswordComplexityTooLow = (bool: boolean) => {
      passwordComplexityTooLow.value = bool;
    };

    const customPasswordErrors = computed(() => {
      if (passwordComplexityTooLow.value) {
        return [
          "Bitte nutzen Sie ein sicheres Passwort. Verwenden Sie für ein sicheres Passwort Zahlen, Buchstaben (klein/groß) und Sonderzeichen.",
        ];
      } else {
        return undefined;
      }
    });

    const generateRequestData = (): RasmusChangePasswordApiData => ({
      action: "CHANGE_PASSWORD",
      data: {
        uid: props.uid,
        password: formData.password,
        passwordRepeat: formData.passwordConfirm,
        oldPassword: formData.oldPassword,
      },
    });

    const resetMessages = () => {
      errors.messages = undefined;
      successMessage.messages = undefined;
    };

    const handleSubmit = async () => {
      resetMessages();
      isSubmitting.value = true;
      const apiRequestData = generateRequestData();
      const response = await rasmusRequest<RasmusChangePasswordApiData>(
        apiRequestData
      );
      isSubmitting.value = false;

      if (response.success) {
        successMessage.messages = "Ihr Passwort wurde erfolgreich geändert.";
      } else {
        const translatedMessage = getTranslatedErrorForMessage(
          response.message
        );

        errors.messages = translatedMessage;
      }
    };

    const customPasswordConfirmErrors = computed(() => {
      if (
        formData.password?.length &&
        formData.passwordConfirm?.length &&
        formData.password !== formData.passwordConfirm
      ) {
        return ["Die Passwörter stimmen nicht überein"];
      } else {
        return undefined;
      }
    });

    return {
      formData,
      handleSubmit,
      setPasswordComplexityTooLow,
      customPasswordErrors,
      isSubmitting,
      successMessage,
      errors,
      customPasswordConfirmErrors,
    };
  },
});
